/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {map, catchError, tap} from 'rxjs/operators';
import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {APP_CONFIG} from '../app.config';
import {MessageService} from "./message.service";
import {Observable, of} from "rxjs";
import {GovernmentEndorsements} from "../model/GovernmentEndorsements";

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable()
export class GovermentEndorsementsService {

  private govEndUrl;


  constructor(private http: HttpClient, private messageService: MessageService) {
    this.govEndUrl = inject(APP_CONFIG).baseUrl + '/api/governmentendorsements';
  }

  getAll(): Observable<GovernmentEndorsements[]> {

    const url = `${this.govEndUrl}/all`;

    return this.http.get<GovernmentEndorsements[]>(url, httpOptions).pipe(
      tap(_ => this.log('got GovernmentEndorsements')),
      catchError(this.handleError<GovernmentEndorsements[]>('getAll'))
    );
  }


  addNew(newEndorsement: GovernmentEndorsements): Observable<GovernmentEndorsements> {
    const url = `${this.govEndUrl}`;
    return this.http.post(url, newEndorsement, httpOptions).pipe(
      map( newEndorsement => newEndorsement as GovernmentEndorsements ));
  }

  updateEndorsement(endorsement: GovernmentEndorsements): Observable<GovernmentEndorsements> {
    var url = `${this.govEndUrl}/${endorsement.governmentEndorsementId}`;
    return this.http.put(url, endorsement, httpOptions).pipe(
      map( endorsement => endorsement as GovernmentEndorsements ));
  }

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  /** Log a message with the MessageService */
  private log(message: string) {
    this.messageService.add('GovermentEndorsementsService: ' + message);
  }
}
